'use client'

import Link from 'next/link'

import {
  SidebarItem,
  SidebarList,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui'

import type { MenuItem } from '@/utils/routes/menu'

type ModuleMenuItemsProps = {
  selectedMenu?: MenuItem
  pathname: string
}

export const ModuleMenuItems = ({
  selectedMenu,
  pathname,
}: ModuleMenuItemsProps) => {
  return (
    <SidebarList isSubList>
      {selectedMenu?.items.map(
        ({ icon: Icon, label, link, disabled, matchPattern, tooltipText }) => {
          if (tooltipText) {
            return (
              <TooltipProvider key={link}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <SidebarItem
                      isSubItem
                      isActive={new RegExp(matchPattern).test(pathname)}
                      disabled={disabled}
                      asChild
                    >
                      <Link href={link}>
                        {Icon && <Icon className="size-5 md:size-6" />}
                        {label}
                      </Link>
                    </SidebarItem>
                  </TooltipTrigger>
                  <TooltipContent>
                    <span className="text-sm font-medium text-system-text-primary">
                      {tooltipText}
                    </span>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )
          }

          return (
            <SidebarItem
              key={link}
              isSubItem
              isActive={new RegExp(matchPattern).test(pathname)}
              disabled={disabled}
              asChild
            >
              <Link href={link}>
                {Icon && <Icon className="size-5 md:size-6" />}
                {label}
              </Link>
            </SidebarItem>
          )
        },
      )}
    </SidebarList>
  )
}

ModuleMenuItems.displayName = 'ModuleMenuItems'
